import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
  TextField,
  FormHelperText,
  Box,
  makeStyles,
  SvgIcon,
  useMediaQuery,
  useTheme
} from '@material-ui/core';
import { Formik } from 'formik';
import * as Yup from 'yup';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { Loyalty as SuggestIcon } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  title: {
    postion: 'relative',
    margin: 0,
    padding: theme.spacing(2),
    textAlign: 'center',
    textTransform: 'capitalize'
  },
  boxWrapper: {
    width: '500px'
  }
}));

const PermissionModal = ({ onClose, open }) => {
  const classes = useStyles();
  const theme = useTheme();
  const mobileDevice = useMediaQuery(theme.breakpoints.down('sm'));

  const ourProducts = [
    { name: 'Vezeti Number' },
    { name: 'SIP Account' },
    { name: 'Vezeti Mobile App' },
    { name: 'Call Logs' },
    { name: 'Others' }
  ];

  const options = [];
  const urgencyOptions = [
    { name: 'Critical' },
    { name: 'Important' },
    { name: 'Nice to have' },
    { name: 'Should have' },
    { name: 'Must have' }
  ];
  return (
    <Dialog maxWidth="lg" onClose={onClose} open={open}>
      <Box className={!mobileDevice ? classes.boxWrapper : undefined}>
        <DialogTitle className={classes.title}>
          <Box display="inline-flex" alignItems="center">
            <SvgIcon>
              <SuggestIcon />
            </SvgIcon>
            <Box mr={1} />
            <Typography variant="h5" color="textPrimary">
              Suggest an improvement
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent dividers>
          <Formik
            initialValues={{
              category: '',
              urgency: '',
              title: '',
              description: '',
              submit: null
            }}
            onSubmit={async (
              values,
              { setErrors, setStatus, setSubmitting }
            ) => {}}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              isSubmitting,
              touched,
              values
            }) => (
              <form noValidate onSubmit={handleSubmit}>
                <Box mb={1}>
                  <Autocomplete
                    // getOptionLabel={(option) => option.text}
                    options={ourProducts}
                    getOptionLabel={(option) => option.name}
                    loading={true}
                    noOptionsText={<small>You have none for now</small>}
                    // value={value}
                    onChange={(e, newValue) => {
                      // setValue(newValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        fullWidth
                        helperText={touched.category && errors.category}
                        error={Boolean(touched.category && errors.category)}
                        label="Product Category:"
                        margin="normal"
                        name="category"
                        variant="outlined"
                        {...params}
                      />
                    )}
                  />
                </Box>
                <Box mb={1}>
                  <Autocomplete
                    options={urgencyOptions}
                    getOptionLabel={(option) => option.name}
                    loading={true}
                    noOptionsText={<small>You have none for now</small>}
                    // value={value}
                    onChange={(e, newValue) => {
                      // setValue(newValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        fullWidth
                        helperText={touched.urgency && errors.urgency}
                        error={Boolean(touched.urgency && errors.urgency)}
                        label="Urgency"
                        margin="normal"
                        name="urgency"
                        variant="outlined"
                        {...params}
                      />
                    )}
                  />
                </Box>
                <Box mb={1}>
                  <TextField
                    error={Boolean(touched.title && errors.title)}
                    fullWidth
                    helperText={touched.title && errors.title}
                    label="Title"
                    margin="normal"
                    name="title"
                    placeholder="Title"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    type="amount"
                    value={values.title}
                    variant="outlined"
                  />
                </Box>
                <Box display="flex" flexDirection="column" mb={1}>
                  <TextField
                    fullWidth
                    margin="normal"
                    name="description"
                    label="Description"
                    helperText={touched.description && errors.description}
                    rows={5}
                    onBlur={handleBlur}
                    multiline={true}
                    onChange={handleChange}
                    value={values.description}
                    variant="outlined"
                  />
                </Box>

                {errors.submit && (
                  <Box mt={3}>
                    <FormHelperText error>{errors.submit}</FormHelperText>
                  </Box>
                )}
                <Divider />
                <Box
                  mt={2}
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Button
                    color="secondary"
                    variant="outlined"
                    onClick={onClose}
                  >
                    Close
                  </Button>
                  <Button type="submit" color="secondary" variant="contained">
                    Submit
                  </Button>
                </Box>
              </form>
            )}
          </Formik>
        </DialogContent>
      </Box>
    </Dialog>
  );
};

PermissionModal.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired
};

PermissionModal.defaultProps = {
  onApply: () => {},
  onClose: () => {}
};

export default PermissionModal;
